import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Button } from '@progress/kendo-react-buttons'
import { Input } from '@progress/kendo-react-inputs'

const AdminNotificationSettings: React.FC = () => {
  // const { t } = useTranslation()
  
  const [threadMessage, setThreadMessage] = useState('')
  const [mentionMessage, setMentionMessage] = useState('')
  const [chatMessage, setChatMessage] = useState('')

  const handleSubmit = () => {
    const dataItem = {
      threadMessage,
      mentionMessage,
      chatMessage
    }
    console.log('Form verisi:', dataItem)
    // Burada form verilerini kaydetme işlemleri yapılabilir
  }

  return (
    <ContentCard>
      <ContentCardHeader>Bildirim Ayarları</ContentCardHeader>
      <ContentCardBody>
        <FormContainer>
          <h2>Bildirim Mesaj Şablonları</h2>
          
          <InputGroup>
            <Label>Thread Mesajları</Label>
            <StyledInput
              value={threadMessage}
              onChange={(e) => setThreadMessage(String(e.target.value || ''))}
              placeholder="Thread mesajları için şablon girin..."
            />
          </InputGroup>

          <InputGroup>
            <Label>Mention Mesajları</Label>
            <StyledInput
              value={mentionMessage}
              onChange={(e) => setMentionMessage(String(e.target.value || ''))}
              placeholder="Mention mesajları için şablon girin..."
            />
          </InputGroup>

          <InputGroup>
            <Label>Normal Chat Mesajları</Label>
            <StyledInput
              value={chatMessage}
              onChange={(e) => setChatMessage(String(e.target.value || ''))}
              placeholder="Normal chat mesajları için şablon girin..."
            />
          </InputGroup>

          <ButtonContainer>
            <StyledButton onClick={handleSubmit}>Kaydet</StyledButton>
          </ButtonContainer>
        </FormContainer>
      </ContentCardBody>
    </ContentCard>
  )
}

export default AdminNotificationSettings

const ContentCard = styled.div`
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2), 0 0 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  overflow: hidden;
  border: 1px solid #e3ebf6;
`

const ContentCardHeader = styled.div`
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 500;
  border-bottom: 1px solid #e3ebf6;
`

const ContentCardBody = styled.div`
  padding: 20px;
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #333;
`

const StyledInput = styled(Input)`
  width: 100%;
  padding: 10px;
  border: 1px solid #e3ebf6;
  border-radius: 4px;
  font-size: 14px;
  
  &:focus {
    border-color: #3151b7;
    outline: none;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`

const StyledButton = styled(Button)`
  background-color: #3151b7;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border: none;
  font-size: 14px;
  cursor: pointer;
  
  &:hover {
    background-color: #2a478f;
  }
`
